import './App.css';
import { gql, useMutation, useQuery, useSubscription } from '@apollo/client';
import { Members } from '../Member/Members';
import { MenuList, MenuItem, ListItemText, Divider, ListItem, Drawer, IconButton, Box, Alert } from '@mui/material';
import { Outlet, useMatches } from "react-router-dom";
import { styled, useTheme } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import { get } from 'lodash';
import { AppMenu } from './AppMenu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MenuIcon from '@mui/icons-material/Menu';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

const DrawerBar = ({ title, components, setComponents }) => {
    const matches = useMatches();

    const { data, subscribeToMore } = useQuery(gql`
        query {
            global_warnings {
                key, warning
            }
        }
    `)

    useEffect(() => {
        // 3. Set up the subscription
        const unsubscribe = subscribeToMore({
            document: gql`
                subscription OnWarningsUpdate {
                    global_warnings {
                        key
                        warning
                    }
                }
            `,
            updateQuery: (prev, { subscriptionData }) => {
                // If there's no new data, return the previous cache state
                if (!subscriptionData.data) return prev;

                const updatedWarnings = subscriptionData.data.global_warnings;
                return {
                    ...prev,
                    global_warnings: updatedWarnings
                };
            }
        });

        // Clean up the subscription when the component unmounts
        return () => unsubscribe();
    }, [subscribeToMore]);

    const [mutate] = useMutation(gql`
        mutation($key: String!) {
        global_warnings_clear(key: $key) {
            key,
            warning
        }
        }
    `)


    useEffect(() => {
        setComponents([])
    }, [ matches ])


  return <Box sx={{ minHeight: "48px", display: "flex", justifyContent: "space-between", width: "100%", mr: "16px"}}>
    <Box sx={{pt: '15px'}}>
      {title}
    </Box>

    {components.map((component, i) => {
      return <Box key={i} sx={{pt: '15px'}}>
        {component}
      </Box>
    })}

    {data?.global_warnings && <Box>
      {data.global_warnings.map((warning, i) => {
        return <Alert
          onClose={() => {
            mutate({
              variables: {
                key: warning.key
              }
            })
          }}
          severity="warning"
          key={i} sx={{ mt: "0px" }}>
          {warning.warning}
        </Alert>
      })}
    </Box>}
  </Box>
}

function App() {
  const [open, setOpen] = useState(true);
  const [title, setTitle] = useState('');
  const [components, setComponents] = useState([])

  const drawerWidth = 256;



  return (
    <div className="App">
      <Drawer
        sx={(theme) => ({
          [theme.breakpoints.up('md')]: {
            width: open ? drawerWidth : 0,
          },
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            [theme.breakpoints.up('md')]: {
              width: open ? drawerWidth : 0,
            },
            boxSizing: 'border-box',
          },
        })}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={() => setOpen(false)}>
            <ChevronLeftIcon />
          </IconButton>
        </DrawerHeader>
        <AppMenu setOpen={setOpen} />
      </Drawer>
      <div className="content">
        <Box sx={{backgroundColor: '#1D7C81', display: 'flex'}}>
          <IconButton sx={{visibility: open ? 'hidden' : 'visible'}} onClick={() => setOpen(true)}>
            <MenuIcon />
          </IconButton>
          <DrawerBar title={title} components={components} setComponents={setComponents} />
        </Box>
        <Outlet context={{setTitle, setComponents}} />

      </div>
    </div>
  );
}

export default App;
